// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "#3097d1",
	"info": "#8eb4cb",
	"success": "#2ab27b",
	"warning": "#cbb956",
	"danger": "#bf5329",
	"demColor1": "#4f628e",
	"demColor2": "#a8b3ce",
	"repColor1": "#aa3939",
	"repColor2": "#de9e9e",
	"indColor1": "gray",
	"indColor2": "#cdcdcd",
	"libColor1": "#d5a200",
	"libColor2": "#ffdd6f",
	"grnColor1": "#006e13",
	"grnColor2": "#08ff33",
	"othColor1": "#007778",
	"othColor2": "#12fdff",
	"investmentIndex": "#b8b8b8",
	"predictedMargin": "#000",
	"winProb": "gray",
	"indexColor1": "#71ad71",
	"volumeBarColor": "#d0e8d0",
	"bodyBg": "#fff",
	"gridBorder": "#e7e7e7",
	"gridLine": "#f3f3f3",
	"black": "#000",
	"gray100": "#f8f9fa",
	"gray200": "#e9ecef",
	"gray400": "#ced4da",
	"gray500": "#adb5bd",
	"gray600": "#6c757d",
	"gray700": "#495057",
	"white": "#fff"
};
export default ___CSS_LOADER_EXPORT___;
